<script setup="">
import { ChevronRightIcon } from "lucide-vue-next";

import Accordion from "@/Components/Accordion.vue";
import AccordionItem from "@/Components/AccordionItem.vue";

import RelationMarketingScriptPartial from "@campaign-js/Components/Partials/RelationMarketingScriptPartial.vue";
import RelationMarketingUtmPartial from "@campaign-js/Components/Partials/RelationMarketingUtmPartial.vue";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const items = [
  {
    title: "분석 스크립트",
    component: RelationMarketingScriptPartial
  },
  {
    title: "UTM",
    component: RelationMarketingUtmPartial
  }
];
</script>

<template>
  <Accordion class="divide-y" :active-index="0">
    <AccordionItem v-for="(item, index) in items" :key="index" class="p-6">
      <template #trigger="{ isActive, open }">
        <div class="flex cursor-pointer items-center justify-between" @click="open">
          <span class="font-bold text-gray-700 dark:text-zinc-100">{{ item.title }}</span>
          <ChevronRightIcon :class="isActive && 'rotate-90 transform'" class="h-4 w-4 transition-transform ease-in-out text-600" />
        </div>
      </template>

      <div class="mt-4 space-y-4">
        <component :is="item.component" :campaign="campaign" :update="update" />
      </div>
    </AccordionItem>
  </Accordion>
</template>
